import { SEARCH_MIN_LAND_SIZE_DEFAULT } from './defaults';

export const getMinLandSizeOrDefault = (input: string): string => {
  const inputAsNumber = Number(input);
  if (Number.isNaN(inputAsNumber) || inputAsNumber < 0) return SEARCH_MIN_LAND_SIZE_DEFAULT;
  return input;
};
